import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu, Popover } from 'antd';
import { saveTemplateItem } from '../../actions/templateActions'

const SubMenu = Menu.SubMenu;

class ExecuteMgrSider extends Component {
    state = {
        current: ''
    }

    componentDidMount() {
        this.setState({ current: this.props.selectKey });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectKey !== this.props.selectKey) {
            this.setState({ current: this.props.selectKey });
        }
    }

    getTemplateNameList = () => {
        const { templateList } = this.props;
        const nameList = templateList.map((item, index) => {
             return <Menu.Item key={item.patientTypeName || item.noPatientTypeName}>
                <Popover placement="right" content={item.followBoardName} trigger="hover">
                    <a
                        onClick={() => this.saveTemplateId(index)}
                        href={`#/executeMgr/template/${item.patientTypeName || item.noPatientTypeName}`}
                    >{item.followBoardName}</a>
                </Popover>
            </Menu.Item>
        });
        return nameList;
    }

    saveTemplateId = (index) => {
        const { templateList } = this.props;
        this.props.templateItemCreator(templateList[index]);
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                <SubMenu
                    key="sub1"
                    title={<span><i className="icon iconfont">&#xe702;</i><span>项目执行</span></span>}
                >
                    <Menu.Item key="visitPeriodPlan">
                        <a href="#/executeMgr/visitPeriodPlan">访视周期计划</a>
                    </Menu.Item>
                    {
                        !isUnBlind &&
                        <Menu.Item key="Type_Pre_Filter">
                            <a href="#/executeMgr/crf/Type_Pre_Filter">预筛记录</a>
                        </Menu.Item>
                    }
                    {
                        !isUnBlind &&
                        <Menu.Item key="Type_Filter">
                            <a href="#/executeMgr/crf/Type_Filter">筛选记录</a>
                        </Menu.Item>
                    }
                    <Menu.Item key="Type_Visit">
                        <a href="#/executeMgr/crf/Type_Visit">访视记录其他字段</a>
                    </Menu.Item>
                    <Menu.Item key="Type_Drop">
                        <a href="#/executeMgr/crf/Type_Drop">退出记录</a>
                    </Menu.Item>
                    <Menu.Item key="violation">
                        <a href="#/executeMgr/Violation">方案违背</a>
                    </Menu.Item>
                    {
                        !isUnBlind &&
                        <Menu.Item key="Type_SAE">
                            <a href="#/executeMgr/crf/Type_SAE">SAE记录</a>
                        </Menu.Item>
                    }
                    <Menu.Item key="qa">
                        <a href="#/executeMgr/qa">Q&A记录</a>
                    </Menu.Item>
                    {
                        isUnBlind &&
                        <Menu.Item key="Type_Drug_Overtemperature">
                            <a href="#/executeMgr/crf/Type_Drug_Overtemperature">药物超温</a>
                        </Menu.Item>
                    }
                    {
                        isUnBlind &&
                        <Menu.Item key="Type_Drug_Breakage">
                            <a href="#/executeMgr/crf/Type_Drug_Breakage">药物破损</a>
                        </Menu.Item>
                    }
                    {
                        isUnBlind &&
                        <Menu.Item key="Type_Instrument_Certificate">
                            <a href="#/executeMgr/crf/Type_Instrument_Certificate">仪器设备校准证书</a>
                        </Menu.Item>
                    }
                    {
                        isUnBlind &&
                        <Menu.Item key="Type_Drug_Blindness">
                            <a href="#/executeMgr/crf/Type_Drug_Blindness">药物破盲</a>
                        </Menu.Item>
                    }
                    {
                        isUnBlind &&
                        <Menu.Item key="Type_Drug_Inventory">
                            <a href="#/executeMgr/crf/Type_Drug_Inventory">药物库存量</a>
                        </Menu.Item>
                    }
                    { this.getTemplateNameList() }
                </SubMenu>
                </Menu>
            </aside>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        templateList: state.templateState.list || [],
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        templateItemCreator: item => dispatch(saveTemplateItem(item)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExecuteMgrSider);



// WEBPACK FOOTER //
// ./src/components/executeMgr/ExecuteMgrSider.js